var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-271 -437.935)"},React.createElement("path",{"fill":"currentColor","stroke":"none","data-name":"Soustraction 1","d":"M-1430-3592.54c-.069,0-6.9-.005-8.6-.46a2.8,2.8,0,0,1-1.94-1.92,29.13,29.13,0,0,1-.46-5.33,29.029,29.029,0,0,1,.46-5.29,2.788,2.788,0,0,1,1.94-2c1.7-.455,8.531-.46,8.6-.46s6.9,0,8.6.42a2.785,2.785,0,0,1,1.939,2,28.958,28.958,0,0,1,.46,5.33,29.053,29.053,0,0,1-.46,5.25,2.788,2.788,0,0,1-1.939,2C-1423.1-3592.545-1429.931-3592.54-1430-3592.54Zm-2.25-10.98h0v6.54l5.75-3.27-5.75-3.27Z","transform":"translate(1712 4045.935)"})));
}

Youtube.defaultProps = {"width":"22.001","height":"15.46","viewBox":"0 0 22.001 15.46"};

module.exports = Youtube;

Youtube.default = Youtube;
